import * as Yup from 'yup';
import {FormikErrors} from 'formik';

export default function<T>(getValidationSchema: (values: T) => Yup.ObjectSchema<T>) {
  return function(values: T) {
    const validationSchema = getValidationSchema(values);
    try {
      validationSchema.validateSync(values, {abortEarly: false});
      return {};
    } catch (validationError) {
      return validationError.inner.reduce((errors: FormikErrors<T>, error: Yup.ValidationError) => {
        return {
          ...(errors as Object),
          [error.path]: error.errors[0]
        };
        // tslint:disable-next-line:align
      }, {});
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/formValidatorFactory.ts